import script from "./Dict.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dict.vue?vue&type=script&setup=true&lang=ts"

import "./Dict.vue?vue&type=style&index=0&id=2eaa642a&lang=less"

const __exports__ = script;

export default __exports__